// extracted by mini-css-extract-plugin
export var auto = "_4b-1";
export var spinner = "_4b-0";